import Entity from '../entity'

export default class Document extends Entity<number>{
    category_id: number;
    filename: string;
    description: string;
}


